// extracted by mini-css-extract-plugin
module.exports = {"tableOverflow":"TablePageTemplate_tableOverflow__1mlkc","centered":"TablePageTemplate_centered__2SdZe","tablePaginator":"TablePageTemplate_tablePaginator__juhKn"};